export const sizes = {
    mobileM: '566px',
    mobile: '320px',
    tablet: '768px',
    tabletL: '1024px',
    laptopS: '1199px',
    laptop: '1280px',
    laptopL: '1444px',
};

export const theme = {
    color: {
        users: [
            '#F27A79',
            '#005334',
            '#5900A9',
            '#7C01FF',
            '#0662EC',
            '#0662EC',
            '#FF5041',
            '#147458',
            '#198038',
            '#A67314',
            '#E2AD49',
            '#48A6B0',
        ],
        whatsappColor: '#25d366'
    },
    fonts: 'Roboto, sans-serif',
    fontSizes: {
        small: '1em',
        medium: '2em',
        large: '3em',
    },
    screenSizes: {
        mobileM: `(min-width: ${sizes.mobileM})`,
        mobile: `(min-width: ${sizes.mobile})`,
        tablet: `(min-width: ${sizes.tablet})`,
        laptopS: `(min-width: ${sizes.laptopS})`,
        laptop: `(min-width: ${sizes.laptop})`,
        laptopL: `(min-width: ${sizes.laptopL})`,
    },
    zindex: {
        header: 100,
        modal: 1000,
        stiky: 101,
    },
};
